import { render } from "./PaginationVue.vue?vue&type=template&id=0bea4440&scoped=true"
import script from "./PaginationVue.vue?vue&type=script&lang=js"
export * from "./PaginationVue.vue?vue&type=script&lang=js"

import "./PaginationVue.vue?vue&type=style&index=0&id=0bea4440&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bea4440"]])

export default __exports__